import { useEffect } from 'react';
import styled from 'styled-components';
import { useFetchSubRModuleData } from '../../../hooks/useFetchSubRModuleData';
import ErrorUI from '../ErrorUI';
import LoadingUI from '../LoadingUI';
import HeaderSection from './HeaderSection';
import TableViewSection from './TableViewSection';
import { useParams, useSearchParams } from 'react-router-dom';
import { getSubRModuleName } from '../../../helpers/utils';
import { parseSubReportQuery } from '../../../helpers/querySchema';

const StockReceipt = () => {
  const { data, isLoading, error, fetchSubRModuleData } = useFetchSubRModuleData();
  const [searchParams] = useSearchParams();

  const routeMatch = useParams();
  const dashboard = routeMatch?.dashboard ?? '';
  const widget = routeMatch?.widget ?? '';
  const reportType = routeMatch?.reportType ?? '';

  const subRModule = getSubRModuleName(dashboard, widget);
  const { primaryValue: value, isValid: isValidQueryParams } = parseSubReportQuery({
    searchParams,
    dashboard,
    widget,
    reportType
  });

  const encodedValue = value ? encodeURIComponent(value) : '';
  const apiBaseUrl =
    dashboard && widget && encodedValue && subRModule && isValidQueryParams
      ? `/api/v1/dar/${dashboard}/${widget}/sub-r/${encodedValue}/${subRModule}`
      : '';

  useEffect(() => {
    if (apiBaseUrl && isValidQueryParams) {
      fetchSubRModuleData(apiBaseUrl);
    }
  }, [apiBaseUrl, isValidQueryParams]);

  const handleRetry = () => {
    fetchSubRModuleData(apiBaseUrl);
  };

  if (isLoading) {
    return <LoadingUI />;
  }

  if (error) {
    return <ErrorUI onRetry={handleRetry} />;
  }

  if (!data) {
    return null;
  }

  return (
    <Wrapper>
      <HeaderSection
        headerTitle={value ?? data?.config?.widget_name ?? 'Stock Receipt'}
        exportData={data?.data ?? []}
      />
      <TableViewSection currentReportWidget={widget} contentData={data} value={value} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export default StockReceipt;
